import { BatchTypeState } from "@/vuex/modules/inventory/batchType/batchType.types";
import { RootState } from "@/vuex/types";
import { Module } from "vuex";
import { actions } from "./batchType.actions";
import { getters } from "./batchType.getters";
import { mutations } from "./batchType.mutations";
import { state } from "./batchType.state";

const namespaced: boolean = true;

export const BatchTypeModule: Module<BatchTypeState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
